





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import AgencyGroups from '@/components/AgencyGroups/AgencyGroups.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'AgencyGroupSettings',
  	components: { AgencyGroups, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getAgencyGroups();
		AgencySettingsModule.getAgencyUsers();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingAgencyGroups;
  	}
}
